import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import AuthHeader from "../../../../Helper/authHeader";
import * as Constants from "../../../../Helper/constants/constants";

const ResetPasswordLab = (props) => {


    return (
        <div className="reset_password_screen">
            <AuthHeader
                header={Constants.RESET_PASSWORD_HEADER}
                description={Constants.RESET_PASSWORD_DESCRIPTION}
            />
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="form">
                            <Form>
                                <Form.Group className="form-group">
                                    <Form.Label>New Password</Form.Label>
                                    <Form.Control
                                        placeholder="************"
                                    />
                                    <span>
                                        <FontAwesomeIcon
                                            icon={faEye}
                                            className="eye_icon"
                                        />
                                        {/* <FontAwesomeIcon
                                            icon={faEyeSlash}
                                            className="eye_icon"
                                        /> */}
                                    </span>
                                </Form.Group>

                                <Form.Group className="form-group">
                                    <Form.Label>Confirm Password</Form.Label>
                                    <Form.Control
                                        placeholder="************"
                                    />
                                    <span>
                                        <FontAwesomeIcon
                                            icon={faEye}
                                            className="eye_icon"
                                        />
                                        {/* <FontAwesomeIcon
                                            icon={faEyeSlash}
                                            className="eye_icon"
                                        /> */}
                                    </span>
                                </Form.Group>
                                <div className="btn_area">
                                    <Button
                                        className="cancelBtn"
                                        type="button"
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        className="submitBtn"
                                        type="submit"
                                    >
                                        Continue
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default ResetPasswordLab;
